class Tabs {
	constructor(options = {}) {
		this.container = document.querySelector(options.container || '.tab-container');
		if (!this.container) return;

		this.tabs = this.container.querySelectorAll(options.buttonSelector || '.tab-button');
		this.contents = this.container.querySelectorAll(options.bodySelector || '.tab-body');

		this.init();
	}

	init() {
		this.tabs.forEach(tab => {
			tab.addEventListener("click", (e) => {
				e.preventDefault();
				const targetId = tab.getAttribute("href");
				this.activateTab(targetId);
			});
		});

		// Activate first tab by default
		if (this.tabs.length > 0) {
			this.activateTab(this.tabs[0].getAttribute("href"));
		}
	}

	activateTab(id) {
		// Remove active class from all tabs and contents
		this.tabs.forEach(tab => tab.classList.remove("active"));
		this.contents.forEach(content => content.classList.remove("active"));

		// Activate the clicked tab and its corresponding content
		const targetContent = this.container.querySelector(id);
		const targetTab = this.container.querySelector(`.tab-button[href="${id}"]`);

		if (targetContent) targetContent.classList.add("active");
		if (targetTab) targetTab.classList.add("active");

		// Remove hash from URL
		history.replaceState(null, null, " ");
	}
}